import { useDispatch } from "react-redux";
import { useContext, useState } from "react";

import {
  connectOutlook,
  connectToGmail,
  removeEmailConfiguration,
} from "../../../actionCreator/emailSetupActionCreater";
import { useAlert } from "../../../context/AlertProvider";
import { EmailContext } from "../../../context/EmailContext";

export const useAuth = () => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const { refetch } = useContext(EmailContext);
  const [error, setError] = useState();

  const handleConnectEmail = async (payload) => {
    let res;
    if (payload.emailDomain === "Gmail") {
      res = await dispatch(connectToGmail({ email: payload?.email }));
    } else {
      res = await dispatch(connectOutlook({ email: payload?.email }));
    }

    if (res?.connectUrl) {
      window.open(res?.connectUrl);
    } else {
      if (res?.response?.status === 403) {
        showAlert(
          "warning",
          "Permission Denied",
          "You do not have permission to perform this action."
        );
      } else {
        setError(res?.response?.data?.title);
        showAlert("error", res?.response?.data?.title);
      }
    }
  };

  const handleRemove = async () => {
    const res = await dispatch(removeEmailConfiguration());
    if (res.status === 204) {
      showAlert("success", `Your Email is Removed!`);
      refetch();
    } else {
       if (res?.response?.status === 403) {
        showAlert(
          "warning",
          "Permission Denied",
          "You do not have permission to perform this action."
        );
      } else {
        showAlert("error", `Something went wrong. Please try again.`);
      }
    }
  };

  return { handleConnectEmail, handleRemove, error, setError };
};
